import { ButtonBase } from '@mui/material';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import CloseRounded from '@mui/icons-material/CloseRounded';
import ArenaSnackbar from 'src/components/arenaSnackbar';
import styles from './styles.module.css';
import CompactSnackbar from './index.styles';

/** Pre-configured snackbar provider for showing snackbars (aler message) */
const AppSnackbarProvider = () => (
  <SnackbarProvider
    autoHideDuration={3000}
    variant="error"
    classes={{
      containerRoot: styles.notistackSnackbarContainer,
    }}
    // Multiplayer speaks in its own voice — see `arenaToast`.
    Components={{
      default: CompactSnackbar,
      success: CompactSnackbar,
      error: CompactSnackbar,
      warning: CompactSnackbar,
      info: CompactSnackbar,
      arena: ArenaSnackbar,
    }}
    action={(snackbarId) => (
      <ButtonBase
        sx={{ bgcolor: 'inherit', p: '6px', borderRadius: '50%' }}
        onClick={() => closeSnackbar(snackbarId)}
      >
        <CloseRounded sx={{ width: '18px', height: 'auto' }} />
      </ButtonBase>
    )}
  />
);

export default AppSnackbarProvider;
